<page-loader *ngIf="!isloaded"></page-loader>
<div class="page-section series-form-page" *ngIf="isloaded">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/admin/user-listing']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/user-listing']">Users</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					{{ user?.fullName || 'User Details' }}
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content" *ngIf="user">
		<div class="user-header">
			<h1>{{ user.fullName || '-' }}</h1>
			<div class="user-header-actions">
				<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
					(click)="onEdit()">Edit User</button>
			</div>
		</div>

		<div class="user-details">
			<div class="detail-item">
				<strong>Email</strong>
				<span>{{ user.email }}</span>
			</div>
			<div class="detail-item">
				<strong>Last Login</strong>
				<span *ngIf="user.loginOn">{{ user.loginOn }}</span>
				<span *ngIf="!user.loginOn" translate>userDetails.neverLoggedIn</span>
			</div>
			<div class="detail-item">
				<strong>Organization</strong>
				<span>{{ user.organizationStr }}</span>
			</div>
		</div>

		<div class="user-actions">
			<button class="app-c-btn app-c-btn--secondary app-c-btn--curve"
				(click)="onResendWelcome()">Resend welcome email</button>
			<button class="app-c-btn app-c-btn--secondary app-c-btn--curve"
				(click)="onResendConfirmation()">Resend confirmation email</button>
			<button class="app-c-btn app-c-btn--danger app-c-btn--curve"
				(click)="onDelete()">Delete this user</button>
		</div>

		<!-- Activity Section -->
		<div class="activity-section">
			<div class="activity-header">
				<h3 translate>userDetails.latestAct</h3>
				<button *ngIf="activity.length >= 20 && showMoreLink"
					class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
					(click)="showMore()" translate>userDetails.more</button>
			</div>
			<div class="table-responsive">
				<table class="table activity-table" *ngIf="activity.length > 0">
					<thead>
						<tr>
							<th>Activity</th>
							<th>Time</th>
							<th>Date</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let activityrow of activity">
							<td>{{ activityrow.message }}</td>
							<td>{{ activityrow.created | date: 'hh:mm a' }}</td>
							<td>{{ activityrow.created | date: 'MM/dd/yy' }}</td>
						</tr>
					</tbody>
				</table>
				<p *ngIf="activity.length === 0" translate class="empty-state">
					userDetails.noneFound</p>
			</div>
		</div>
	</div>
</div>
